module.exports = __webpack_public_path__ + "resource/img/close2.f7526a83.svg";